import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface IMoreIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const MoreIcon = ({ fill, size = 14, title, id = 'more-icon' }: IMoreIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill ?? 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-more-vertical"
            >
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="12" cy="5" r="1"></circle>
                <circle cx="12" cy="19" r="1"></circle>
            </svg>
        </SIconSpan>
    )
}

export default MoreIcon
